import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-553f3705"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign-up-container" }
const _hoisted_2 = {
  ref: "scrollContainerRef",
  class: "sign-up-form-container",
  "aria-label": "회원가입 폼"
}
const _hoisted_3 = { class: "modal body-wrapper" }
const _hoisted_4 = { id: "modal-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "회원가입" }),
        _createElementVNode("main", _hoisted_2, [
          _createVNode($setup["DynamicSignupForm"], {
            ref: "dynamicSignupForm",
            rankCode: $setup.rankCode ?? $setup.RankCode.REG,
            onOnClickSignupButton: $setup.requestSignup
          }, null, 8 /* PROPS */, ["rankCode"])
        ], 512 /* NEED_PATCH */),
        ($setup.scrollContainerRef)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 0,
              class: "scroll-top-btn",
              container: $setup.scrollContainerRef
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true),
        ($setup.shouldShowCompleteSignUp)
          ? (_openBlock(), _createBlock($setup["Modal"], {
              key: 1,
              title: "회원가입 완료",
              okButtonTitle: "확인",
              onOnClickOkButton: $setup.onClickConfirmSignUp,
              role: "dialog",
              "aria-modal": true,
              "aria-labelledby": "modal-title"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString($setup.getCompleteSignUpText), 1 /* TEXT */)
                ])
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}